import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Sticky banner that stays at the top of every page during the
// invite-only beta. Communicates that no services are being delivered
// to residents yet. Shows signup/login CTAs when not authenticated and
// the user's email + logout when they are.

export function BetaBanner() {
  const { user, logout, loading } = useAuth();

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 bg-terracotta text-cream"
      role="region"
      aria-label="Beta status"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-2 sm:py-2.5 flex items-center justify-between gap-3 text-xs sm:text-sm">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <span className="inline-block px-2 py-0.5 bg-cream text-terracotta tracking-[0.15em] uppercase text-[10px] font-semibold whitespace-nowrap">
            Beta
          </span>
          <span className="text-cream/95 truncate">
            <span className="hidden sm:inline">MowKind is in invite-only beta. </span>
            No mowing services are being delivered yet — accounts are for platform testing.
          </span>
        </div>

        {!loading && (
          <div className="flex items-center gap-3 text-xs shrink-0">
            {user ? (
              <>
                <Link
                  to="/dashboard"
                  className="hidden sm:inline-block hover:underline tracking-wider uppercase text-[11px]"
                >
                  Dashboard
                </Link>
                {user.role === 'admin' && (
                  <Link
                    to="/admin"
                    className="hidden md:inline-block hover:underline tracking-wider uppercase text-[11px]"
                  >
                    Admin
                  </Link>
                )}
                <span className="hidden lg:inline text-cream/85">
                  {user.email}
                </span>
                <button
                  onClick={() => void logout()}
                  className="underline hover:text-cream/70 tracking-wider uppercase text-[11px]"
                >
                  Sign out
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="hover:underline tracking-wider uppercase text-[11px]"
                >
                  Sign in
                </Link>
                <Link
                  to="/signup"
                  className="bg-cream text-terracotta px-3 py-1 tracking-wider uppercase text-[11px] font-medium hover:bg-cream/85 transition-colors"
                >
                  Join beta
                </Link>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
